import type { PortalViewOutput } from '@garage/shared';
import { buttonClasses } from '../../ui/Button.js';
import { PhoneIcon } from '../../ui/icons.js';

type Garage = PortalViewOutput['garage'];

/** Numéro composable pour un lien `tel:` (chiffres et « + » seulement). */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

/** Vrai si le garage a renseigné au moins une coordonnée. */
export function hasContact(g: Garage): boolean {
  return Boolean(g.address || g.phone || g.openingHours);
}

/**
 * Coordonnées du garage telles que renvoyées par l'API (réglages « Marque ») : adresse, téléphone
 * cliquable, horaires. Rien n'est affiché pour une coordonnée absente ; rien n'est écrit en dur.
 */
export function GarageContact({ garage, compact = false }: { garage: Garage; compact?: boolean }) {
  if (!hasContact(garage)) return null;
  return (
    <div
      className={
        compact ? 'space-y-2' : 'space-y-4 rounded-2xl border border-line bg-surface p-(--card-p)'
      }
    >
      {garage.phone ? (
        <a
          href={telHref(garage.phone)}
          className={buttonClasses({ variant: 'primary', block: true, className: 'sm:w-auto' })}
        >
          <PhoneIcon /> Appeler le garage · {garage.phone}
        </a>
      ) : null}
      {garage.address ? (
        <div>
          <p className="text-sm font-medium text-ink-3">Adresse</p>
          <p className="whitespace-pre-line text-ink">{garage.address}</p>
        </div>
      ) : null}
      {garage.openingHours ? (
        <div>
          <p className="text-sm font-medium text-ink-3">Horaires</p>
          <p className="whitespace-pre-line text-ink">{garage.openingHours}</p>
        </div>
      ) : null}
    </div>
  );
}
